<template>
  <section>
    <!-- 统计文字 -->
    <el-row style="padding:15px;background:#fff">
    	
      <el-col :sm="24" :xs="24" >
        <el-row :gutter="10">
          <el-button type="primary" plain @click="changeDate(1)" id="yesterday">昨天</el-button>
          <el-button type="primary" plain @click="changeDate(2)"  >前天</el-button>
          <el-date-picker class="xs24" v-model="dateVal" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="今天" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>

          <!--新增筛选类型条件-->
          <el-select v-model="pdata.type" filterable clearable  placeholder="请选择" @change="typeChange">
            <el-option label="非矩阵" value="1"></el-option>
            <el-option label="矩阵" value="2"></el-option>
            <el-option label="换量" value="3"></el-option>
          </el-select>
          
          <el-button type="primary" @click="batchAddProduct">导入</el-button>
          <el-button size="medium" type="text" @click="downloadTemp">导入模板下载</el-button>

        </el-row>
      </el-col>
      <!--<el-col :sm="8" :xs="24">
        <div style="float:right;text-align: right;">
          <el-row :gutter="10">
            <searchApp  class="xs24" @getid="changeId" compare="issued" :pholder="pholder"></searchApp>
          </el-row>
        </div>
      </el-col>-->
    </el-row>
    <el-table :data="list" style="width:auto" stripe row-key="issued_app_id"  show-summary :summary-method="getSummaries"    :height="height"   :row-class-name="tableRowClassName" @expand-change="expands" class="selfTable" v-if="dateVal[0]!==dateVal[1]&&isFetch"   :default-sort = "{prop: '_visit_uv_new', order: 'descending'}">
      <el-table-column type="expand" prop="name">

        <template slot-scope="s">
           <el-table :data="s.row.exData" :show-header="false" >
           	  <el-table-column prop="d_date" label="" align="center" width="48px">
           	  	<template slot-scope="scope">
                    <span>&nbsp;</span>
                </template>
           	  </el-table-column>
              <el-table-column prop="d_date" label="日期" align="center" ></el-table-column>
              <el-table-column prop="d_date" label="" align="center">
           	  	<template slot-scope="scope">
                    <span>&nbsp;</span>
                </template>
           	  </el-table-column>
              <el-table-column v-if="pdata.type!=3" prop="visit_uv_new" label="预计新增用户" align="center" ></el-table-column>
              <el-table-column v-if="pdata.type!=3" prop="cost" label="预计花费" align="center" :formatter="fixed2Formatter">
              	<template slot-scope="scope">
                    	￥<span>{{scope.row.cost}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="_visit_uv_new" label="实际计价用户" align="center" ></el-table-column>
              <el-table-column v-if="pdata.type==3" prop="_visit_uv" label="实际活跃用户" align="center" ></el-table-column>
              <el-table-column prop="_cost" label="实际花费" align="center" :formatter="fixed2Formatter">
              	<template slot-scope="scope">
                    	￥<span>{{scope.row._cost}}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="pdata.type!=3" prop="cost_per" label="实际买量单价" align="center" :formatter="fixed2Formatter">
              	<template slot-scope="scope">
                    	￥<span>{{scope.row.cost_per}}</span>
                </template>
              </el-table-column>
              
              <el-table-column prop="" label="" align="center" >
                <template slot-scope="scope">
                    <span>&nbsp;</span>
                </template>
              </el-table-column>
           </el-table>
        </template>
      </el-table-column>

      <el-table-column prop="issued_app_id" label="ID" align="center"   ></el-table-column>
      <el-table-column prop="app_name" label="发行游戏名称" align="center" ></el-table-column>
      
      <el-table-column v-if="list.length>0 && list[0].visit_uv_new!=undefined && pdata.type!=3" prop="visit_uv_new" label="预计新增用户" align="center"  sortable   :sort-method="(a,b)=>{return (a.visit_uv_new-0)-(b.visit_uv_new-0)}" >
      		<template slot-scope="scope">
          	<span class="red">{{scope.row.visit_uv_new}}</span>
        	</template>
      </el-table-column>
      <el-table-column v-if="list.length>0 && list[0].cost!=undefined && pdata.type!=3" prop="cost" label="预计花费" :formatter="fixed2Formatter" align="center" sortable   :sort-method="(a,b)=>{return (a.cost-0)-(b.cost-0)}">
      		<template slot-scope="scope">
          	￥<span class="red">{{scope.row.cost}}</span>
        	</template>
      </el-table-column>
      
      <el-table-column v-if="list.length>0 && list[0]._visit_uv_new!=undefined" prop="_visit_uv_new" label="实际计价用户" align="center" sortable   :sort-method="(a,b)=>{return (a._visit_uv_new-0)-(b._visit_uv_new-0)}">
        <template slot-scope="scope">
          <span :class="scope.row.gray?'gray-text':'red'">{{scope.row._visit_uv_new}}</span>
        </template>
      </el-table-column>
  
      <el-table-column v-if="list.length>0 && list[0]._visit_uv!=undefined && pdata.type==3" prop="_visit_uv" label="实际活跃用户" align="center" sortable   :sort-method="(a,b)=>{return (a._visit_uv-0)-(b._visit_uv-0)}" >
        <template slot-scope="scope">
          <span :class="scope.row.gray?'gray-text':'red'">{{scope.row._visit_uv}}</span>
        </template>
      </el-table-column>
      
      <el-table-column v-if="list.length>0 && list[0]._cost!=undefined" prop="_cost" label="实际花费" :formatter="fixed2Formatter" align="center" sortable   :sort-method="(a,b)=>{return (a._cost-0)-(b._cost-0)}">
        <template slot-scope="scope">
          	￥<span :class="scope.row.gray?'gray-text':'red'">{{fixed2Formatter('','',scope.row._cost)}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="list.length>0 && list[0].cost_per!=undefined && pdata.type!=3" prop="cost_per" label="实际买量单价" :formatter="fixed2Formatter" align="center" sortable   :sort-method="(a,b)=>{return (a.cost_per-0)-(b.cost_per-0)}">
      	<template slot-scope="scope">
          	￥<span class="red">{{scope.row.cost_per}}</span>
        	</template>
      </el-table-column>
      

      
      <el-table-column prop="" label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="$router.push({name:'成本日报详情',params:{issued_app_id:scope.row.issued_app_id},query:{sdate:pdata.sdate,edate:pdata.edate}})">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
		
		
		<el-table :data="list" style="width:auto" stripe row-key="issued_app_id"  show-summary :summary-method="getSummaries"    :height="height"   :row-class-name="tableRowClassName"  v-if="dateVal[0]===dateVal[1]&&isFetch">


      <el-table-column prop="issued_app_id" label="ID" align="center"  ></el-table-column>
      <el-table-column prop="app_name" label="发行游戏名称" align="center"  ></el-table-column>
      
      <el-table-column  v-if="list.length>0 && list[0].visit_uv_new!=undefined && pdata.type!=3" prop="visit_uv_new" label="预计新增用户" align="center"  sortable   :sort-method="(a,b)=>{return (a.visit_uv_new-0)-(b.visit_uv_new-0)}">
      	 <template slot-scope="scope">
          <span class="red">{{scope.row.visit_uv_new}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="list.length>0 && list[0].cost!=undefined && pdata.type!=3" prop="cost" label="预计花费" :formatter="fixed2Formatter" align="center" sortable   :sort-method="(a,b)=>{return (a.cost-0)-(b.cost-0)}">
      	 <template slot-scope="scope">
          	￥<span class="red">{{scope.row.cost}}</span>
        </template>
      </el-table-column>
      
      
      
      <el-table-column v-if="list.length>0 && list[0]._visit_uv_new!=undefined" prop="_visit_uv_new" label="实际计价用户" align="center" sortable   :sort-method="(a,b)=>{return (a._visit_uv_new-0)-(b._visit_uv_new-0)}">
        <template slot-scope="scope">
          <span :class="scope.row.gray?'gray-text':'red'">{{scope.row._visit_uv_new}}</span>
        </template>
      </el-table-column>

      
      <el-table-column v-if="list.length>0 && list[0]._visit_uv!=undefined && pdata.type==3" prop="_visit_uv" label="实际活跃用户" align="center" sortable   :sort-method="(a,b)=>{return (a._visit_uv-0)-(b._visit_uv-0)}">
        <template slot-scope="scope">
          <span :class="scope.row.gray?'gray-text':'red'">{{scope.row._visit_uv}}</span>
        </template>
      </el-table-column>
      
      
      <el-table-column v-if="list.length>0 && list[0]._cost!=undefined" prop="_cost" label="实际花费" :formatter="fixed2Formatter" align="center" sortable   :sort-method="(a,b)=>{return (a._cost-0)-(b._cost-0)}" >
        <template slot-scope="scope">
          	￥<span :class="scope.row.gray?'gray-text':'red'">{{fixed2Formatter('','',scope.row._cost)}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="list.length>0 && list[0].cost_per!=undefined && pdata.type!=3" prop="cost_per" label="实际买量单价" :formatter="fixed2Formatter" align="center" sortable   :sort-method="(a,b)=>{return (a.cost_per-0)-(b.cost_per-0)}">
      	 <template slot-scope="scope">
          	￥<span class="red">{{scope.row.cost_per}}</span>
        </template>
      </el-table-column>
      
      <el-table-column prop="cost_back.day_0" label="当天回本" align="center"  sortable   :sort-method="(a,b)=>{return parseFloat(a.cost_back.day_0)- parseFloat(b.cost_back.day_0)}"></el-table-column>
      <el-table-column prop="cost_back.day_3" label="3天回本" align="center" sortable   :sort-method="(a,b)=>{return  parseFloat(a.cost_back.day_3)- parseFloat(b.cost_back.day_3)}"></el-table-column>
      <el-table-column prop="cost_back.day_7" label="7天回本" align="center"  sortable   :sort-method="(a,b)=>{return  parseFloat(a.cost_back.day_7)- parseFloat(b.cost_back.day_7)}"></el-table-column>
      <el-table-column prop="cost_back.day_14" label="14天回本" align="center"  sortable   :sort-method="(a,b)=>{return  parseFloat(a.cost_back.day_14)- parseFloat(b.cost_back.day_14)}"></el-table-column>
      
      <el-table-column prop="" label="操作" align="center"  >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="$router.push({name:'成本日报详情',params:{issued_app_id:scope.row.issued_app_id},query:{sdate:pdata.sdate,edate:pdata.edate}})">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--<el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>-->
		
		  <el-dialog title="导入" :visible.sync="batchDialog" width="1000px" :close-on-click-modal="false">
      <el-form :model="form"  ref="ruleForm" label-width="140px">

				
				<el-upload
				v-if="batchForm.length==0"
			  class="upload-demo"
			  drag
			  :action="url"
				 :headers="headers"
				  :on-success="batchSuccess"
				  name="file"
				  :show-file-list="false"
				 >
			  <i class="el-icon-upload"></i>
			  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
			  <div class="el-upload__tip" slot="tip">只能上传csv文件</div>
			</el-upload>
      </el-form>
       
      <el-row :gutter="5" class="yltt" v-if="batchForm.length>0" >
       	<el-col  :span="24">{{batchTips==0?'导入预览':'导入二次确认'}}</el-col>
       </el-row>
       
   
       
       <el-row :gutter="5" v-for="item,index in batchForm" class="yllist" :class="'yllist'+index" v-if="batchForm.length>0&&batchTips=='0'">
       		<el-col  :span="3" v-for="(citem,idx) in  item">
       				{{citem}}
       		</el-col>	
       		<el-col  :span="3" class="blue" v-if="index>0" @click.native="deleteBatch(index)" style="cursor: pointer;">
       			删除
       			
       		</el-col>
       		
       </el-row>
       
        <el-row :gutter="5" v-for="item,index in batchForm" class="yllist" :class="'yllist'+index" v-if="batchForm.length>0&&batchTips=='1'" >
       		<el-col  :span="idx<4?3:2" v-for="(citem,idx) in  item">
       				{{citem}}
       		</el-col>	
       		<el-col  :span="2" class="blue" v-if="index>0" @click.native="deleteBatch(index)" style="cursor: pointer;">
       			删除
       			
       		</el-col>
       		
       </el-row>
       
      


      <div slot="footer" class="dialog-footer" v-if="batchForm.length>0">
        <el-button @click="batchCalcel">取 消</el-button>
        <el-button type="primary" @click="batchSubmit">{{batchTips=='0'?'确认':'再次确认'}}</el-button>
      
       
      </div>
    </el-dialog>

  </section>
</template>

<script>

import $ from "jquery";
import { getcostDaily,getcostDailyForDays, getAppid ,baseUrl ,importAldChannelData} from "../../api/api";

export default {
  data() {
    return {
      chartColumn: null,
      pholder: "",
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_id: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000  * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        // sdate: "2019-04-15",
        // edate: "2019-04-15",
        type:"1"
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000  * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      list:[], //所有数据
      isFetch:false,
      
      batchDialog:false,
      batchForm:[],
			batchTips:'0',
			url:baseUrl+"issuedAldChannelData/preview",
			headers:{
          'token':this.$cookie.getCookie("login")
     },
      form: {
      },
      height:900,
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
					this.$router.push({ path:'/costDaily/index', query: {sdate:this.pdata.sdate, edate: this.pdata.edate} });
					
					this.getList();
     
        }
      },
      deep: true
    },
    
    
    
  },
  methods: {
    nullFormatter(row, column, cellValue, index){
      if(cellValue=='-'){
        return '-';
      }else if(cellValue==0 || cellValue==null || cellValue==undefined){
        return '0';
      }else{
        return cellValue;
      }
    },
    fixed2Formatter(row, column, cellValue, index){
      if(cellValue=='-'){
        return '-';
      }else if(cellValue==0 || cellValue==null || cellValue==undefined){
        return '0.00';
      }else{
        return parseFloat(cellValue).toFixed(2);
      }
    },
  	getSummaries(param) {
      var self=this;
	    const { columns, data } = param;
	    const sums = [];
	    columns.forEach((column, index) => {
	      if (index === 0) {
	        sums[index] = '合计';
	        return;
	      }
	       if (index === 1) {
	        sums[index] = '-';
	        return;
	      }
	     
	     
	      const values = data.map(item => Number(item[column.property]));
	      if (!values.every(value => isNaN(value))) {
	        sums[index] = values.reduce((prev, curr) => {
	          const value = Number(curr);
	          if (!isNaN(value)) {
	            return prev + curr;
	          } else {
	            return prev;
	          }
	        }, 0);
	        if(this.dateVal[0]!=this.dateVal[1]){
	        	 if(index!=3&&index!=5){
		        	 sums[index] = '￥'+sums[index].toFixed(2);
		        }
	        }
	        if(this.dateVal[0]==this.dateVal[1]){
	        	 if(index!=2&&index!=4){
		        	 sums[index] =  '￥'+ sums[index].toFixed(2);
		        }
	        }
	        
	       
	        
	      } else {
	        sums[index] = '-';
	      }
	    });
	
	    return sums;
	  },
  	tableRowClassName({ row, rowIndex }) {
//    if (row.clickok_uv == 0 && row.num != 0) {
//      return "warning-row";
//    }
      return "";
    },
    expands(r, es) {

      var isshou = false;
      if (es.length > 0) {
        es.forEach(v => {
          if (v.issued_app_id == r.issued_app_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = `issued_app_id=${r.issued_app_id}&sdate=${this.dateVal[0]}&type=${this.pdata.type}&edate=${
          this.dateVal[1]
        }`;

        getcostDailyForDays(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            r.exData = res.data.list;
            this.$forceUpdate();
          }
         
        });
      }
    },
    getList() {
    	this.isFetch=false;
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getcostDaily(p, this.$cookie.getCookie("login")).then(res => {
      	this.isFetch=true;
        if (res.code == 200) {
          // "总访问人数", "总新增访问人数", "总收入","利润","买量成本","ROI"
          if(res.data.list&&res.data.list.length>0){
          	 res.data.list.forEach((x,i) => {
	            	x.keyid='key'+i;
	              x.exData = [];
	            });
	            this.list=res.data.list;
          }
          else{
          		this.list=[];
          }
          
          
        }
      });
    },
    typeChange(v){
      this.pdata.type = v;
      this.list=[];
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24* s)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
    changeId(res) {
      this.pdata.issued_app_id = res;
      this.getList();
    },
    downloadTemp(){
  		window.location.href='/static/channel_data_import.csv';
  	},
    batchSuccess(response, file, fileList){
  		if(response.code==200){
  			this.batchForm=response.data;
  		}
  	},
    batchAddProduct(){
  		this.batchDialog=true;
  	},
  	batchCalcel(){
    	this.batchDialog = false;
    	this.batchForm=[];
    	this.batchTips="0"
    },
    deleteBatch(index){
    	 this.batchForm.splice(index,1);
    },
    batchSubmit(){
    	
   		var p ={
	  		"overwrite":this.batchTips,
				"data":JSON.parse(JSON.stringify(this.batchForm)),
      };
      p.data.forEach((v,i)=>{
      	
      	if(v.length>7){
      		v.pop()
      	}
      })
      importAldChannelData(p, this.$cookie.getCookie("login")).then(response => {
      	debugger;
        if (response.data.code == 200) {
        	
         	 if(response.data.data.length>0){
         	 	 
        			this.batchForm=response.data.data;
        			this.batchForm.unshift(["日期","发行游戏","渠道名称","新增用户","活跃用户","单价","点击单价"]);
        			this.batchTips="1";
        			
        			
         	 }
         	 else{
         	 	 this.$message({ message: "导入成功", type: "success" });
         	 	 this.batchDialog = false;
         	 	 this.batchForm=[];
         	 	 this.batchTips="0";
         	 	 this.getList();
         	 }
        }
        else{
        	this.$message.error('导入失败');
        	 
        }
     });
    },
  },
  created(){
  	
  	console.log($(window).height()-200);
  	this.height=$(window).height()-200
  },

  mounted() {
  	
		
    if (Object.keys(this.$route.params).length > 0) {
      this.pdata.sdate = this.$route.params.sdate;
      this.pdata.edate = this.$route.params.edate;
      this.pdata.app_id = this.$route.params.app_id;
      this.pholder = this.$route.params.name;
    }
    if(this.$route.query.sdate){
    	  this.pdata.sdate=this.$route.query.sdate;
    }
    if(this.$route.query.edate){
    	 this.pdata.edate=this.$route.query.edate;
    }
  	this.dateVal = [this.pdata.sdate,this.pdata.edate];
   
    this.getList();
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}

</style>


<style scoped="scoped">
	.red{
		color: #FF0000;
	}
	.gray-text{
	  color: #000 !important;
	}
	.red{
		color: #FF4949 !important;
	}
</style>


// WEBPACK FOOTER //
// costDaily.vue?133d1964